module.exports = __webpack_public_path__ + "static/img/110122.ce8a5a22.png";